import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Col, Drawer, Popconfirm, Row, Space, Table } from 'antd'
import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { AppstreamForm } from './AppstreamForm'
import { useDeleteAppstreamMutation } from './mutation'
import { useAppstreamsQuery } from './query'
import { AWS_REGIONS } from '~/utils/constants'

const AppstreamList: React.FC = () => {
  const { id } = useParams()
  const { data, isLoading } = useAppstreamsQuery(id)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [selected, setSelected] = useState<any>(null)
  const deleteMutation = useDeleteAppstreamMutation()
  const queryClient = useQueryClient()

  return <>
    <Table
      sticky
      title={() =>
        <Row>
          <Col flex="200px">
            <h3>Fleets</h3>
          </Col>
          <Col flex="auto">
            <Row justify="end">
              <Button type="primary" onClick={() => { setIsDrawerOpen(true) }}>
                New fleet
              </Button>
            </Row>
          </Col>
        </Row>
      }
      size="small"
      tableLayout="auto"
      loading={isLoading}
      pagination={false}
      footer={() => (
        <Row justify="start">
          <span>Total: {data.length} fleets</span>
        </Row>
      )}
      dataSource={data}
      rowKey='id'
      columns={[
        {
          title: 'Id',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: 'Stack/Fleet name',
          dataIndex: 'stack_name',
          key: 'stack_name'
        },
        {
          title: 'Region',
          key: 'region',
          render: item => AWS_REGIONS.find(i => i.code === item.region_code)?.name
        },
        {
          title: 'Associated servers',
          key: 'associated_servers',
          render: item => {
            if (item.servers == null) {
              return null
            }
            return <div>
              {item.servers.map(i =>
                <span key={i.id}>
                  {i.name}<br />
                </span>)}
            </div>
          }
        },
        {
          title: 'Actions',
          key: 'actions',
          render: (item: { name: string, id: number }) => {
            return (
              <Space size="middle">
                <Button type="primary" icon={<EditOutlined />}
                  onClick={() => {
                    setSelected(item)
                    setIsDrawerOpen(true)
                  }} />
                <Popconfirm
                  title={`Do you want to delete server ${item.name}?`}
                  onConfirm={() => {
                    deleteMutation.mutate(item.id, {
                      onSuccess: () => {
                        void queryClient.invalidateQueries({ queryKey: ['courses', id] })
                      }
                    })
                  }}
                  okText="YES"
                >
                  <Button danger type='primary' icon={<DeleteOutlined />} />
                </Popconfirm>
              </Space>
            )
          }
        }
      ]}
    />

    <Drawer
      open={isDrawerOpen}
      size={720}
      onClose={() => {
        setIsDrawerOpen(false)
        setSelected(null)
      }}
      destroyOnHidden
    >
      <AppstreamForm
        appstream={selected}
        courseId={Number(id)}
        onSuccess={() => {
          setIsDrawerOpen(false)
          setSelected(null)
          queryClient.invalidateQueries({ queryKey: ['courses', id] })
        }} />
    </Drawer>
  </>
}

export default AppstreamList
